import React from "react";
import clsx from "clsx"; // <-- import clsx for combining classes
import {
	Box,
	Paper,
	Typography,
	Button,
	TableContainer,
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell,
	IconButton,
	Switch,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

import { useDockerManagementContext } from "../DockerManagementProvider";
import { useStyles } from "./styles";
import apiClient from "../../../../auth/apiClient";
import useCancellationToken from "../../../../hooks/useCancellationToken";

const ComposesTable = () => {
	const classes = useStyles();

	const {
		state: { configuredComposes: tableRows },
		actions: {
			addClick,
			editClick,
			displayDevices,
			updateConfiguration,
			deleteClick,
			getModeNameFromModeId,
			getChipsetNameFromModeId,
			showError,
		},
	} = useDockerManagementContext();

	const { execute: updateActiveStatus } = useCancellationToken({
		func: async function ({ values, cancelToken }) {
			const mappedValues = {
				...values,
				deviceIds: values.deviceIds?.length ? values.deviceIds : null,
				active: !values.active,
			};
			const response = await apiClient.put("docker-support", mappedValues, {
				headers: { "Content-Type": "application/json" },
				cancelToken,
			});
			updateConfiguration(response.data);
		},
		errHandleFunc: (err) => {
			showError("Failed to Update script configuration: " + err);
		},
	});

	return (
		<>
			<Box display="flex" my={2}>
				<Box flexGrow={1}>
					<Typography variant="h5" className={clsx(classes.subheader)} gutterBottom>
						Docker Compose Configurations
					</Typography>
				</Box>
				<Box mx={2}>
					<Button variant="outlined" onClick={() => addClick()}>
						Add
					</Button>
				</Box>
			</Box>
			<TableContainer component={Paper} style={{ overflowX: "auto" }}>
				<Table aria-label="simple table" className={classes.table}>
					<TableHead>
						<TableRow>
							<TableCell className={clsx(classes.colName)}>Name</TableCell>
							<TableCell className={clsx(classes.colChipset)} align="center">
								Chipset
							</TableCell>
							<TableCell className={clsx(classes.colMode)} align="center">
								Mode
							</TableCell>
							<TableCell className={clsx(classes.colDevices)} align="center">
								Devices
							</TableCell>
							<TableCell className={clsx(classes.colActions)} align="center">
								Actions
							</TableCell>
						</TableRow>
					</TableHead>

					<TableBody>
						{tableRows.map((row) => (
							<TableRow key={row.id}>
								<TableCell
									className={clsx(classes.colName)}
									component="th"
									scope="row"
								>
									{row.yamlFile}
								</TableCell>

								<TableCell
									className={clsx(classes.colChipset)}
									align="center"
								>
									{row.chipset == null
										? <span className={clsx(classes.na)}>N/A</span>
										: getChipsetNameFromModeId(row.chipset)}
								</TableCell>

								<TableCell className={clsx(classes.colMode)} align="center">
									{row.mode == null ? <span className={clsx(classes.na)}>N/A</span> : getModeNameFromModeId(row.mode)}
								</TableCell>

								<TableCell
									className={clsx(classes.colDevices)}
									align="center"
								>
									{Array.isArray(row.deviceIds) && row.deviceIds.length ? (
										<Button variant="outlined" onClick={() => displayDevices(row.id)}>
											Display Devices
										</Button>
									) : (
										<span className={clsx(classes.na)}>N/A</span>
									)}
								</TableCell>

								<TableCell
									className={clsx(classes.colActions)}
									align="center"
								>
									<IconButton 
										color="primary"
										aria-label="edit" onClick={() => editClick(row.id)} title="Edit">
										<EditIcon />
									</IconButton>
									<Switch
										color="primary"
										title={row.active ? "Deactivate" : "Activate"}								
										checked={row.active}
										onChange={async () =>
											await updateActiveStatus({ values: row })
										}
									/>
									<IconButton
										title="Delete"
										color="primary"
										aria-label="delete"
										onClick={() => deleteClick(row.id)}
									>
										<DeleteIcon />
									</IconButton>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</>
	);
};

export default ComposesTable;
